import { render } from "./statistics.vue?vue&type=template&id=df57dea0&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"

import "./statistics.vue?vue&type=style&index=0&id=df57dea0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-df57dea0"

export default script